import NavBar from "components/NavBar";
import React from "react";
import Insights from "../pages/Insights";
import Simulation from "../pages/Simulation";

const V2Routes = () => (
  <>
    <Insights />
    <Simulation />
  </>
);

export default V2Routes;
